var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',{staticStyle:{"font-weight":"600"},attrs:{"label":_vm.label,"outlined":_vm.outlined,"single-line":_vm.singleline,"placeholder":_vm.placeholder,"rounded":_vm.rounded,"type":_vm.type,"dense":_vm.dense}})}
var staticRenderFns = []

export { render, staticRenderFns }